import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import YouTube from 'react-youtube';

import { getSecondsFromTimelineLabel } from '../helpers/PlayerHelper';

import EventBus from 'eventbusjs';

let player = null;

export default class YouTubePlayer extends Component {
  constructor(props) {
    super(props);
    this._onReady = this._onReady.bind(this);
  }

  static propTypes = {
    videoId: PropTypes.string.isRequired, // defaults -> null
    id: PropTypes.string, // defaults -> null
    className: PropTypes.string, // defaults -> null
    opts: PropTypes.object, // defaults -> {}
    onReady: PropTypes.func, // defaults -> noop
    onPlay: PropTypes.func, // defaults -> noop
    onPause: PropTypes.func, // defaults -> noop
    onEnd: PropTypes.func, // defaults -> noop
    onError: PropTypes.func, // defaults -> noop
    onStateChange: PropTypes.func, // defaults -> noop
    onPlaybackRateChange: PropTypes.func, // defaults -> noop
    onPlaybackQualityChange: PropTypes.func // defaults -> noop
  };

  static defaultProps = {
    startAt: 0,
    autoPlay: 1
  };

  componentDidMount() {
    this.registerTimelineClickListener();
  }

  _onReady(event) {
    // access to player in all event handlers via event.target

    player = event.target;
    const { startAt, autoPlay } = this.props;
    if (startAt) {
      player.seekTo(startAt);
    }
  }

  registerTimelineClickListener() {
    EventBus.addEventListener('PLAY_AT', evnt => {
      const time = evnt.target;
      const seconds = getSecondsFromTimelineLabel(time);
      player.seekTo(seconds);
      player.playVideo();
    });
  }

  render() {
    const { url, autoPlay } = this.props;

    const opts = {
      width: '100%',
      playerVars: {
        autoplay: autoPlay
      }
    };

    return (
      <YouTube
        className="youtube-video"
        videoId={this.props.videoId}
        opts={opts}
        onReady={this._onReady}
      />
    );
  }
}
